import React, { useEffect, useState } from 'react';
import '../../styles/style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASE from './../../config.jsx';
import Loader from "../Loader";
import { DateRange } from "react-date-range";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';
import json from "qs"; // theme css file
import { format } from 'date-fns';
import Swal from "sweetalert2";
import { convertDisplayedPrices } from "../../currency";



const Hero = ({ title, backgroundImage, locations, setLoading }) => {

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [bedroomsOpen, setBedroomsOpen] = useState(false);
  const [dateOpen, setDateOpen] = useState(false);


  const [selectedLocations, setSelectedLocations] = useState([]);
  const [minBedrooms, setMinBedrooms] = useState(2);
  const [maxBedrooms, setMaxBedrooms] = useState(4);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [appliedMinBedrooms, setAppliedMinBedrooms] = useState(null);
  const [appliedMaxBedrooms, setAppliedMaxBedrooms] = useState(null);
  const BEDROOM_MAX = 10;

  const today = new Date();
  const strippedToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());


  const [state, setState] = useState([
    {
      startDate: undefined,
      endDate: undefined,
      key: 'selection'
    }
  ]);

  const [rangeSelected, setRangeSelected] = useState(false);



  const handleLocationChange = (event) => {
    const value = parseInt(event.target.value);

    setSelectedLocations((prevSelected) =>
      prevSelected.includes(value)
        ? prevSelected.filter((id) => id !== value)
        : [...prevSelected, value]
    );
  };
  const toggleLocationDropdown = () => {
    setDropdownOpen(!dropdownOpen);
    setBedroomsOpen(false);
    setDateOpen(false);
  };

  const toggleBedroomsDropdown = () => {
    setBedroomsOpen(!bedroomsOpen);
    setDropdownOpen(false);
    setDateOpen(false);
  };

  const toggleDateDropdown = () => {
    setDateOpen(!dateOpen);
    setDropdownOpen(false);
    setBedroomsOpen(false);
  };

  const handleClearLocations = () => {
    setSelectedLocations([]);
  };

  const handleApplyLocations = () => {
    setDropdownOpen(false);
  };

  const handleMinIncrement = () => {
    setMinBedrooms((prevMin) => {
      const newMin = Math.min(BEDROOM_MAX, prevMin + 1);
      setMaxBedrooms((prevMax) => (prevMax < newMin ? newMin : prevMax));
      return newMin;
    });
  };

  const handleMaxIncrement = () => {
    setMaxBedrooms((prevMax) => Math.min(BEDROOM_MAX, prevMax + 1));
  };

  const handleMinDecrement = () => {
    setMinBedrooms((prevMin) => Math.max(1, prevMin - 1));
  };

  const handleMaxDecrement = () => {
    setMaxBedrooms((prevMax) => {
      const newMax = Math.max(1, prevMax - 1);
      setMinBedrooms((prevMin) => (prevMin > newMax ? newMax : prevMin));
      return newMax;
    });
  };

  const handleClearBedrooms = () => {
    setMinBedrooms(2);
    setMaxBedrooms(4);
    setAppliedMinBedrooms(null);
    setAppliedMaxBedrooms(null);
  };


  const handleApplyBedrooms = () => {
    setAppliedMinBedrooms(minBedrooms);
    setAppliedMaxBedrooms(maxBedrooms);
    setBedroomsOpen(false);
  };


  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleClearDates = () => {
    setStartDate("");
    setEndDate("");
  };

  const handleApplyDates = () => {
    setDateOpen(false);
  };

  const [reference, setReference] = useState("");
  const handeReferenceChange = (event) => {
    setReference(event.target.value)
  }

  const scrollToSection = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: "smooth",
    });
  };

  const selectedCount = selectedLocations.length;

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const startDate = state[0].startDate;
    const endDate = state[0].endDate;
    /*
        if (selectedLocations.length === 0 && reference == '') {
          Swal.fire({
            icon: 'warning',
            title: 'Attention!',
            text: 'Please select at least one Location.',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK',
            customClass: {
              popup: 'custom-popup-class'
            }
          }).finally(setLoading(false));
          return;
        }
    
     */

    const formData = {
      selectedLocations,
      minBedrooms: appliedMinBedrooms,
      maxBedrooms: appliedMaxBedrooms,
      reference,
      startDate: startDate ? format(startDate, 'yyyy-MM-dd') : '',
      endDate: endDate ? format(endDate, 'yyyy-MM-dd') : '',

    };

    console.log("Search form data", formData);

    axios.post(BASE.BASE_API_URL + `/api/search`, formData)
      .then(async (res) => {

        // console.log("Form values saved successfully!", res);

        const searchState = {
            filteredProperties: await convertDisplayedPrices(res.data.Filtered_properties || []),
            selectedLocations: formData.selectedLocations,
            startDate: formData.startDate,
            endDate: formData.endDate,
            message: res.data.message || "",
            minBedrooms: appliedMinBedrooms,
            maxBedrooms: appliedMaxBedrooms,
            currentPage: 1,
            searchKey: Date.now(),
        };

        try {
          sessionStorage.removeItem("sunboundSearchView");
          sessionStorage.setItem("sunboundSearchResults", JSON.stringify({
            filteredProperties: searchState.filteredProperties,
            selectedLocations: searchState.selectedLocations,
            startDate: searchState.startDate,
            endDate: searchState.endDate,
            message: searchState.message,
            minBedrooms: searchState.minBedrooms,
            maxBedrooms: searchState.maxBedrooms,
          }));
        } catch (e) {
          /* ignore quota / private mode */
        }

        navigate("/search", { state: searchState });
      })
      .catch((err) => {
        console.error("Error saving form:", err);
        try {
          sessionStorage.removeItem("sunboundSearchView");
        } catch (e) {
          /* ignore */
        }
        navigate("/search", {
          state: {
            filteredProperties: [],
            message: "No properties matched the search term.",
            currentPage: 1,
            searchKey: Date.now(),
          }
        });
      }).finally(() => {
        setLoading(false);
      })
  };




  function formatDateToYMD(date) {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }


  return (
    <div className="hero_section_home" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="container">
        <h1>{title}</h1>

        <form onSubmit={handleSubmit}>
          <div className="hero_drop_down">
            <div className="dropdown-wrapper">


              {<div className="locations">
                <button type="button" className="dropdown-button " onClick={toggleLocationDropdown}>
                  {selectedCount === 0
                    ? "Location"
                    : `${selectedCount} Resort${selectedCount > 1 ? 's' : ''} Selected`}
                  <FontAwesomeIcon icon={faChevronDown} />
                </button>
                {dropdownOpen && (
                  <div className="dropdown-content">
                    {locations.map((items, index) => (
                      <label key={index}>
                        <input
                          type="checkbox"
                          name="selectedLocations"
                          value={items.id}
                          checked={selectedLocations.includes(items.id)}
                          onChange={handleLocationChange}
                        />
                        {items.name}
                      </label>
                    ))}
                    <div className="dropdown-buttons locations-button">
                      <button type="button" className="clear-button" onClick={handleClearLocations}>
                        Clear
                      </button>
                      <button type="button" className="apply-button" onClick={handleApplyLocations}>
                        Apply
                      </button>
                    </div>
                  </div>


                )}
              </div>}

              <div className="bedrooms">
                <button type="button" className="dropdown-button" onClick={toggleBedroomsDropdown}>
                  {appliedMinBedrooms !== null && appliedMaxBedrooms !== null
                    ? `Bedrooms (${appliedMinBedrooms} - ${appliedMaxBedrooms})`
                    : "Bedrooms"}
                  <FontAwesomeIcon icon={faChevronDown} />
                </button>

                {bedroomsOpen && (
                  <div className="dropdown-content-bedrooms">
                    <div className="bedroom-steppers">
                      <div className="bedroom-stepper">
                        <span className="bedroom-stepper-label">Min Bed {minBedrooms}</span>
                        <div className="bedroom-stepper-controls">
                          <button
                            type="button"
                            className="bedroom-stepper-btn"
                            onClick={handleMinDecrement}
                            aria-label="Decrease minimum bedrooms"
                            disabled={minBedrooms <= 1}
                          >
                            <FontAwesomeIcon icon={faMinus} />
                          </button>
                          <button
                            type="button"
                            className="bedroom-stepper-btn"
                            onClick={handleMinIncrement}
                            aria-label="Increase minimum bedrooms"
                            disabled={minBedrooms >= BEDROOM_MAX}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                          </button>
                        </div>
                      </div>

                      <div className="bedroom-stepper">
                        <span className="bedroom-stepper-label">Max Bed {maxBedrooms}</span>
                        <div className="bedroom-stepper-controls">
                          <button
                            type="button"
                            className="bedroom-stepper-btn"
                            onClick={handleMaxDecrement}
                            aria-label="Decrease maximum bedrooms"
                            disabled={maxBedrooms <= 1}
                          >
                            <FontAwesomeIcon icon={faMinus} />
                          </button>
                          <button
                            type="button"
                            className="bedroom-stepper-btn"
                            onClick={handleMaxIncrement}
                            aria-label="Increase maximum bedrooms"
                            disabled={maxBedrooms >= BEDROOM_MAX}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="dropdown-buttons">
                      <button
                        type="button"
                        className="clear-button"
                        onClick={handleClearBedrooms}
                      >
                        Reset
                      </button>
                      <button
                        type="button"
                        className="apply-button"
                        onClick={handleApplyBedrooms}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <div className="date">
                <button type="button" className="dropdown-button" onClick={toggleDateDropdown}>
                  {state[0].startDate && state[0].endDate
                    ? `${formatDateToYMD(state[0].startDate)} - ${formatDateToYMD(state[0].endDate)}`
                    : "Date"}
                  <FontAwesomeIcon icon={faChevronDown} />
                </button>
                {dateOpen && (
                  <div className="calendar-div" style={{ position: "absolute", transform: 'scale(0.85)', transformOrigin: 'top left' }}>

                    <DateRange
                      editableDateInputs={true}
                      onChange={(item) => {
                        setState([item.selection]);
                        const { startDate, endDate } = item.selection;

                        if (startDate && endDate && startDate.getTime() !== endDate.getTime()) {
                          setRangeSelected(true);
                          setDateOpen(false);
                        }
                      }}
                      moveRangeOnFirstSelection={false}
                      ranges={[
                        {
                          ...state[0],
                          startDate: state[0].startDate || new Date(),
                          endDate: state[0].endDate || new Date(),
                        },
                      ]}
                      months={2}
                      direction="horizontal"
                      showDateDisplay={false}
                    />
                  </div>

                )}
              </div>


              <div className="reference">
                <input className="reference-input" onChange={handeReferenceChange} type="text" placeholder="Reference" name="reference" />
              </div>

            </div>

            <div className="find-villas-button">
              <button className="find-villas-btn" >
                Find Villas
              </button>
            </div>

            <div className="dowm_image_hero" onClick={scrollToSection} style={{ cursor: "pointer" }}>
              <FontAwesomeIcon icon={faChevronDown} size="2x" />
            </div>
          </div>

        </form>

      </div>
    </div>
  );
};

export default Hero;